import { render, staticRenderFns } from "./WebSiteCourseBannerFormModal.vue?vue&type=template&id=bb72b7f8&scoped=true"
import script from "./WebSiteCourseBannerFormModal.vue?vue&type=script&lang=js"
export * from "./WebSiteCourseBannerFormModal.vue?vue&type=script&lang=js"
import style0 from "./WebSiteCourseBannerFormModal.vue?vue&type=style&index=0&id=bb72b7f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb72b7f8",
  null
  
)

export default component.exports